import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { MomentModule } from 'ngx-moment';

import { AdminsAvatarsComponent, type AvatarUser } from '@core/account-ui';
import type { TaskData } from '@core/tellent-assistant-types';
import { AppKind } from '@core/tellent-types';
import { CheckboxComponent } from '@core/user-interface-legacy';

import { injectAssistantEntityUrl } from '../../assistant-entity-url';
import { ListCardComponent } from '../../list-card/list-card.component';

@Component({
  selector: 'rt-list-item-task',
  imports: [ListCardComponent, CheckboxComponent, AdminsAvatarsComponent, MomentModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-task.component.html',
  styleUrl: './list-item-task.component.less',
})
export class ListItemTaskComponent {
  private readonly entityUrl = injectAssistantEntityUrl();

  protected readonly avatarUsers = computed<AvatarUser[]>(
    () =>
      this.data().admins?.map((admin, index) => ({
        id: index,
        name: admin.name,
        initials: admin.initials ?? '',
        photoThumbUrl: admin.avatarUrl ?? '',
        hasAvatar: !!admin.avatarUrl,
      })) ?? [],
  );
  protected readonly url = computed(() =>
    this.entityUrl(AppKind.Recruitee, { id: 'task', params: { taskId: this.data().id } }),
  );

  public readonly data = input.required<TaskData>();
}
